import { render, staticRenderFns } from "./StudentLibraryPage.vue?vue&type=template&id=ec391b10&scoped=true"
import script from "./StudentLibraryPage.vue?vue&type=script&lang=js"
export * from "./StudentLibraryPage.vue?vue&type=script&lang=js"
import style0 from "./StudentLibraryPage.vue?vue&type=style&index=0&id=ec391b10&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec391b10",
  null
  
)

export default component.exports